/**
 * Copyright (c) 2025 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Eugen Becker <e.becker@techdivision.com>
 */
import React from 'react';
import {createRoot} from 'react-dom/client';
import {HeatCalculatorComp} from './HeatCalculatorComp';

const container = document.getElementById('heat-load-calculator');
const nodeData = JSON.parse(container.dataset.props);
container.removeAttribute('data-props');
const root = createRoot(container);
root.render(<HeatCalculatorComp
  introText={nodeData.props.introText}
  energyTypes={nodeData.props.energyTypes} />,
);
